import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CdrDumpFileImportResource {
  private http = inject(HttpClient);

  private _baseUrl = '/services/cisco/reporting/cucm-cdrs/imports/dump-files';

  post(file: File): Observable<void> {
    const formData = new FormData();
    formData.append('upload', file);
    return this.http.post<void>(this._baseUrl, formData);
  }
}
